// DEPRECATION NOTICE: Originally from UG LMS, should be removed. https://descomplica.slack.com/archives/CJFJQQY1K/p1713359793357089

import { MicrocertificateModel } from '@/models/microcertificates/microcertificate.model';

export interface MicrocertificateState {
  microcertificates?: MicrocertificateModel[];
  isGenerating?: boolean;
}

const state: MicrocertificateState = {
  microcertificates: [],
  isGenerating: false,
};

export default state;
